import React, {useEffect, useState} from 'react';
import { Modal, Button } from 'react-bootstrap';
import {getLabel} from "../../language";
import connect from "react-redux/src/components/connect";

const mapStateToProps = (state, ownProps) => {
    return {
        anonymousMode: state.user.anonymousMode
    }
}

const AudienceSelectionModal = props => {

    const members = (audienceMembers) => {
        let memberString = '';
        (audienceMembers || [] ) && audienceMembers.map((member, i) => {
            if(i === 0) {
                memberString = member.displayName;
            }
            if(i === 1 || i === 2) {
                memberString += `, ${member.displayName}`;
            }
            if(i === 3) {
                memberString += ` and ${audienceMembers.length - 3} more`;
            }
            if(i === audienceMembers.length-1){
                return (
                    <span>{memberString}</span>
                )
            }

        })
        return (
            <span>{memberString}</span>
        )
    };
    return (
        <Modal className={`${props.anonymousMode ? "dark" : ""}`} show={props.state.audienceSelectionModal} onHide={props.audienceSelectionModal}>
            <Modal.Header>
                <Modal.Title>
                    {getLabel(71)}
                </Modal.Title>
                <button type="button" className="close" data-dismiss="modal" onClick={props.audienceSelectionModal} aria-hidden={props.state.audienceSelectionModal}>×</button>
            </Modal.Header>
            <Modal.Body>
              { props.forVote ?
                <div>
                      {
                        props.audiencesList ? props.audiencesList.map((audience, i) => (
                            <fieldset key={i} className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`} style={{padding: 5, paddingLeft: 15}}>
                              <div className="form-check">
                                <input type="checkbox" disabled={!audience.members.length} id={`${audience.id}`} onChange={props.onChange}
                                       checked={props.state.selectedAudiencesIds.indexOf(audience.id) >= 0}/>
                                <label htmlFor={`${audience.id}`}>{audience.name}</label>
                                <div className={`audience-members`} style={{paddingLeft: 30, fontSize: 13}}>
                                  {
                                    audience.members.length ?
                                      members(audience.members)
                                      :
                                      <div className="text-danger">{getLabel(208)}</div>
                                  }
                                </div>
                              </div>
                            </fieldset>
                          )) :
                          <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`}>{getLabel(79)}</fieldset>
                      }
                </div>
                :
                <div>
                  {
                    props.audiencesList.length ? props.audiencesList.map((audience, i) => (
                        <fieldset key={i} className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`} style={{padding: 5, paddingLeft: 15}}>
                          <div className="form-check">
                            <input type="checkbox" id={`${audience.id}`}  disabled={!audience.members.length} onChange={props.onChange}
                                   checked={props.state.selectedAudienceForView ? (props.state.selectedAudiencesIds || []).indexOf(audience.id) >= 0 : (props.state.selectedAudiencesIdsForReply || []).indexOf(audience.id) >= 0}/>
                            <label for={`${audience.id}`}>{audience.name}</label>
                            <div className="audience-members" style={{paddingLeft: 30, fontSize: 13}}>
                              {
                                audience.members.length ?
                                  members(audience.members)
                                  :
                                  <div className="text-danger">{getLabel(208)}</div>
                              }
                            </div>
                          </div>
                        </fieldset>
                      )) :
                      <fieldset className={`form-group privacy-list${props.anonymousMode ? "-dark cw" : ""}`}>{
                        props.state.viewMyPostsAndComments === 1 && !(props.state.errorMessage && props.state.errorMessage.message2) ? getLabel(79)
                          : props.state.errorMessage.message2 || getLabel(209)}
                      </fieldset>
                  }
                </div>
              }
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.audienceSelectionModal}className={`m-t-30 btn-primary${props.anonymousMode ? "-dark" : " custom-dp"}`}>{getLabel(80)}</Button>
            </Modal.Footer>
        </Modal>
    )

};

export default connect(mapStateToProps, null)(AudienceSelectionModal)
